<template>
  <img
    class="warning-icon"
    :style="{ left: this.left ? this.left + 'px' : 0, top: top + 'px' }"
    alt="proposition 65 consumption warning symbol"
    src="@/assets/warning.svg"
  />
</template>

<script>
export default {
  name: "Proposition65WarningSymbol",
  props: {
    left: Number,
    top: Number,
  },
};
</script>

<style scoped>
.warning-icon {
  height: 14px;
  position: absolute;
}
</style>
